import React, { useRef, useState } from "react"

import { useElementClientSize, useUpdateableState } from "@lib"

export const Segment: React.FunctionComponent<{
    title: string,
    value: string | number,
    selected?: boolean,
    onClick?: (value: string | number) => void
}> = ({ title, value, selected, onClick }) => {
    return (
        <div className={["flex-1", selected ? "text-white-900" : "text-primary-900", "cursor-pointer"].join(" ")}
            onClick={() => onClick && onClick(value)}>
            <span>{title}</span>
        </div>
    )
}

export const SegmentedControl: React.FunctionComponent<{
    value?: string | number,
    onChange?: (value: string | number) => void
}> = ({ value, onChange, children }) => {
    const controlRef = useRef<HTMLDivElement>(null)
    const [controlWidth, controlHeight] = useElementClientSize(controlRef)

    const segments = React.Children.toArray(children)
        .filter((each: any) => each.type === Segment)
    const selectedSegment = segments.find((each: any) => {
        return each && each.props && each.props.value === value
    })

    const [selectedIndex, setSelectedIndex] = useUpdateableState<number>(
        selectedSegment ? segments.indexOf(selectedSegment) : 0
    )

    return (
        <div ref={controlRef} className="relative text-callout text-center uppercase">
            <div className="absolute bg-primary-900 top-0 bottom-0 rounded-[8px]"
                style={{ minWidth: `${controlWidth / segments.length}px`, left: selectedIndex ? (selectedIndex * (controlWidth / segments.length)) : 0}}
            />
            <div className="relative border-[2px] border-primary-900 rounded-[8px] text-primary-900">
                <div className="flex px-[8px] py-[12px]">
                    {segments.map((each: any, index) =>
                        <Segment title={each.props.title} value={each.props.value} selected={index === selectedIndex} key={each.key}
                            onClick={(value) => {
                                if (selectedIndex !== index) {
                                    setSelectedIndex(index)
                                    onChange && onChange(value)
                                }
                            }}
                            />)
                    }
                </div>
            </div>
        </div>
    )
}
